import React from 'react'
import classNames from 'classnames'
import { LinkButton } from '@/atoms/Button'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { ParagraphSM, TitleMD } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'

export interface PayItForwardCheckoutGuildCtaProps {
  wrapperClassName?: string
  backgroundImage?: string
  phoneImage?: string
  ctaLogo?: string
  guildDeepLink: string
  ctaButtonText: string
  ctaTitleText: string
  ctaDescriptionText?: string
  showDeepLink?: boolean
  handleCtaClick: () => void
  showTopCta: boolean
}

export const PayItForwardCheckoutGuildCta: React.FC<PayItForwardCheckoutGuildCtaProps> = ({
  wrapperClassName,
  backgroundImage,
  phoneImage,
  ctaLogo,
  guildDeepLink,
  ctaButtonText,
  ctaTitleText,
  ctaDescriptionText,
  showDeepLink,
  handleCtaClick,
  showTopCta,
}) => {
  return (
    <>
      {!showTopCta && (
        <div
          className={classNames('flex h-[85vh] w-full flex-col p-0 md:hidden md:h-0', wrapperClassName)}
          style={{
            backgroundImage: backgroundImage,
          }}
        >
          <div className="relative h-full w-full items-center justify-center backdrop-blur-xl">
            <ResponsiveBackgroundImage
              src={backgroundImage ?? getCloudinaryImageUrl({ path: '/v1694104235/Show.png' })}
              className="h-full w-full bg-cover bg-center bg-no-repeat"
            />
            <div className="flex h-full w-full items-center justify-center bg-white/[0.05] backdrop-blur-xl">
              {phoneImage && (
                <img
                  src={phoneImage}
                  className={
                    'absolute inset-0 mx-auto mt-10 h-[70%] md:left-[12%] md:m-auto md:mx-0 lg:left-[3%] lg:h-[67%] xl:left-[16%] xl:h-[72%] 2xl:left-[24%] 2xl:h-[80%]'
                  }
                  alt={'phone-image'}
                />
              )}
              <div className="absolute inset-y-0 my-auto mb-10 flex h-fit w-fit max-w-[80vw] flex-col items-center rounded-2xl bg-core-gray-800/[0.92] px-4 py-8 text-center text-white backdrop-blur-3xl md:right-[10%] md:mb-auto md:max-w-[420px] md:px-6 lg:right-[8%] xl:right-[10%] 2xl:right-[15%] 3xl:right-[20%]">
                {ctaLogo && <img src={ctaLogo} className={'pb-8'} alt={'phone-image'} />}
                <TitleMD
                  className="max-w-[85%] pb-4 text-lg leading-[22px] md:max-w-[75%] md:text-2xl md:leading-8"
                  weight="bold"
                >
                  {ctaTitleText}
                </TitleMD>
                {ctaDescriptionText && (
                  <ParagraphSM className="text-sm font-light md:max-w-[90%] md:text-base md:leading-7">
                    {ctaDescriptionText}
                  </ParagraphSM>
                )}
                <LinkButton
                  aria-label="join-the-guild"
                  href={showDeepLink ? guildDeepLink : paths.guild.index}
                  variant="oxide-bright"
                  className="mt-4 flex w-fit min-w-[216px] justify-center p-4 capitalize"
                  onClick={handleCtaClick}
                >
                  {ctaButtonText}
                </LinkButton>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
